export const PLAN_LIMITS = {
  starter: {
    properties: 3,
    tenants: 6,
    storage_gb: 1,
    listings: 0,
  },
  pro: {
    properties: 10,
    tenants: 25,
    storage_gb: 5,
    listings: 3,
  },
  premium: {
    properties: Infinity,
    tenants: Infinity,
    storage_gb: 20,
    listings: Infinity,
  },
} as const

export const CURRENCIES = [
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "CHF", name: "Swiss Franc", symbol: "Fr" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "PLN", name: "Polish Złoty", symbol: "zł" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "RON", name: "Romanian Leu", symbol: "lei" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв" },
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ" },
  { code: "CAD", name: "Canadian Dollar", symbol: "$" },
  { code: "AUD", name: "Australian Dollar", symbol: "$" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺" },
  { code: "BDT", name: "Bangladesh Taka", symbol: "৳" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
] as const

export const COUNTRIES = [
  { code: "NL", name: "Netherlands" },
  { code: "GB", name: "United Kingdom" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "PT", name: "Portugal" },
  { code: "BE", name: "Belgium" },
  { code: "AT", name: "Austria" },
  { code: "CH", name: "Switzerland" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PL", name: "Poland" },
  { code: "CZ", name: "Czech Republic" },
  { code: "HU", name: "Hungary" },
  { code: "RO", name: "Romania" },
  { code: "BG", name: "Bulgaria" },
  { code: "IE", name: "Ireland" },
  { code: "GR", name: "Greece" },
  { code: "HR", name: "Croatia" },
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "TR", name: "Turkey" },
  { code: "BD", name: "Bangladesh" },
  { code: "IN", name: "India" },
] as const

export const PROPERTY_TYPES = [
  { value: "apartment", label: "Apartment" },
  { value: "house", label: "House" },
  { value: "studio", label: "Studio" },
  { value: "room", label: "Room in House" },
  { value: "commercial", label: "Commercial Space" },
] as const

export const PROPERTY_STATUSES = [
  { value: "available", label: "Available" },
  { value: "occupied", label: "Occupied" },
  { value: "renovation", label: "Under Renovation" },
  { value: "for_sale", label: "Listed for Sale" },
  { value: "archived", label: "Archived" },
] as const

export const LEASE_TYPES = [
  { value: "fixed", label: "Fixed Term" },
  { value: "rolling", label: "Rolling / Periodic" },
  { value: "short", label: "Short Let" },
  { value: "student", label: "Student Let" },
  { value: "seasonal", label: "Seasonal" },
] as const

export const MAINTENANCE_CATEGORIES = [
  { value: "plumbing", label: "Plumbing" },
  { value: "electrical", label: "Electrical" },
  { value: "heating", label: "Heating & HVAC" },
  { value: "appliances", label: "Appliances" },
  { value: "structural", label: "Structural" },
  { value: "windows_doors", label: "Windows & Doors" },
  { value: "pest_control", label: "Pest Control" },
  { value: "cleaning", label: "Cleaning" },
  { value: "garden", label: "Garden & Exterior" },
  { value: "other", label: "Other" },
] as const

export const EXPENSE_CATEGORIES = [
  { value: "maintenance_repair", label: "Maintenance & Repair" },
  { value: "insurance", label: "Insurance" },
  { value: "property_tax", label: "Property Tax" },
  { value: "mortgage", label: "Mortgage" },
  { value: "management_fee", label: "Management Fee" },
  { value: "utilities", label: "Utilities" },
  { value: "advertising", label: "Advertising" },
  { value: "legal", label: "Legal & Professional" },
  { value: "renovation", label: "Renovation" },
  { value: "cleaning", label: "Cleaning" },
  { value: "other", label: "Other" },
] as const

export const DOCUMENT_CATEGORIES = {
  property: [
    { value: "ownership_deed", label: "Ownership Deed" },
    { value: "building_insurance", label: "Building Insurance" },
    { value: "floor_plan", label: "Floor Plan" },
    { value: "epc_certificate", label: "EPC Certificate" },
    { value: "gas_safety", label: "Gas Safety Certificate" },
    { value: "electrical_safety", label: "Electrical Safety (EICR)" },
    { value: "other", label: "Other" },
  ],
  tenant: [
    { value: "id_document", label: "ID Document" },
    { value: "proof_of_income", label: "Proof of Income" },
    { value: "reference_letter", label: "Reference Letter" },
    { value: "other", label: "Other" },
  ],
  lease: [
    { value: "lease_agreement", label: "Lease Agreement" },
    { value: "inventory", label: "Inventory Report" },
    { value: "deposit_protection", label: "Deposit Protection" },
    { value: "amendment", label: "Lease Amendment" },
    { value: "other", label: "Other" },
  ],
} as const
